// import React from "react";
// import "./VideoBannerSection.css";
// import video1 from "../Images/video1.mp4"; // Place your video in `public/Videos/` or `src/Videos/`

// const VideoBannerSection = () => {
//   return (
//     <section className="video-banner-section">
//       <video
//         className="background-video"
//         autoPlay
//         muted
//         loop
//         playsInline
//         src={video1}
//         type="video1/mp4"
//       />
//       <div className="video-overlay">
//         <h1>Experience Luxury Like Never Before</h1>
//         <p>Timeless Diamond Ring Jewelry for Every Occasion</p>
//         <button className="explore-btn">Explore Now</button>
//       </div>
//     </section>
//   );
// };

// export default VideoBannerSection;


import React, { useEffect, useState } from "react";
import axios from "axios";
import "./VideoBannerSection.css";

const VideoBannerSection = () => {
  const [bannerData, setBannerData] = useState({
    video: "",
    heading: "",
    subtitle: ""
  });

  useEffect(() => {
    // Fetch Video Banner data from API
    const fetchBannerData = async () => {
      try {
        const response = await axios.get('https://spinelleapi.emedha.in/admin/advertise/get/advertise');
        const videoBannerData = response.data.data.find(ad => ad.type === "Video Banner");

        if (videoBannerData) {
          setBannerData({
            video: videoBannerData.video,
            heading: videoBannerData.heading,
            subtitle: videoBannerData.subtitle
          });
        }
      } catch (error) {
        console.error("Error fetching video banner data:", error);
      }
    };

    fetchBannerData();
  }, []);

  return (
    <section className="video-banner-section">
      {bannerData.video ? (
        <video
          className="background-video"
          autoPlay
          muted
          loop
          playsInline
          src={bannerData.video}
          type="video/mp4"
        />
      ) : (
        <div>Loading video...</div>
      )}
      <div className="video-overlay">
        <h1>{bannerData.heading || "Loading..."}</h1>
        <p>{bannerData.subtitle || "Please wait, loading details..."}</p>
        <button className="explore-btn">Explore Now</button>
      </div>
    </section>
  );
};

export default VideoBannerSection;
